<template>
  <div style="width: 100%; overflow-x: hidden;">
    <span style="margin-bottom: 10px; display: block">Kết quả bài test</span>
    <div style="background: #F6F6F6; padding: 20px 15px; border-radius: 5px; position: relative;">
      <div class="result" v-if="taskDetail.resultTest">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center; justify-content: center; gap: 5px">
            <i :class="taskDetail?.resultType === 'Speaking' ? 'el-icon-mic' : 'el-icon-document'" style="background: lightskyblue; display: block; color: white; padding: 4px; border-radius: 9999px"></i>
            <span>{{ taskDetail?.resultType }}</span>
          </div>
          <span>Số điểm: <span style="font-weight: 600">{{ taskDetail?.point ?? '' }}</span></span>
        </div>
        <div :class="isShowMore ? 'height-more' : 'height-default'">
          <div v-if="taskDetail.resultType === 'Writing'">
            <ResultDetail v-for="(item, index) in taskDetail.resultTest" :index="index + 1" :result="item"/>
          </div>
          <div v-if="taskDetail.resultType === 'Speaking'">
            <ResultDetail :result="taskDetail.resultTest"/>
          </div>
        </div>
      </div>
      <button v-if="taskDetail.resultTest" class="btn-view__more" @click="handleViewMore">
        Xem chi tiết
        <i style="color: #1da1f2;" :class="isShowMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </button>
      <div v-else>
        Chưa có kết quả.
      </div>
    </div>
  </div>
</template>

<script>

import ResultDetail from "@/view/pages/manage-exam-schedule/component/ResutlDetail.vue";

export default {
  name: 'ResultTest',
  components: {ResultDetail},
  props: {
    taskDetail: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      isShowMore: false,
    }
  },
  methods: {
    handleViewMore() {
      this.isShowMore = !this.isShowMore
    },
  }
}
</script>

<style scoped>
.result {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  background: white;
  border: 1px solid lightgray;
  position: relative;
  margin-bottom: 10px;
}
.height-default {
  height: 150px;
  overflow: hidden;
  padding-bottom: 30px
}
.height-more {
  height: 460px;
  overflow-y: auto;
  padding-bottom: 30px
}
.btn-view__more {
  display: flex;
  align-items: center;
  gap: 4px;
  position: absolute;
  left: 50%;
  font-weight: 700;
  font-size: 14px;
  transform: translateX(-50%);
  bottom: 0;
  color: #1da1f2;
  padding: 5px 12px;
}
</style>